import axios from "axios";

export default axios.create({
  baseURL: "https://contact-json-server-vercel.vercel.app/",
});

// static / mock data
// https://contact-json-server-vercel.vercel.app

// http://localhost:5000
